<div class="chip" [class.error]=error() [class.light]=light() [class.dark]=dark()>
    @if(icon(); as icon) {
        <i [class]="'far fa-' + icon"></i>
    }

    {{text()}}
</div>
